"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compositeKey = void 0;

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/prefer-default-export
var compositeKey = function compositeKey(parentKey, key) {
  return parentKey ? "".concat(parentKey, ".").concat(key) : key;
};

exports.compositeKey = compositeKey;